import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../root-saga/root-state';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.languages || initialState;

export const selectLanguages = createSelector(
  [selectSlice],
  (state) => state.items,
);

export const selectLanguagesLoading = createSelector(
  [selectSlice],
  (state) => state.loading,
);

/** Convenience map of code -> language for label lookups. */
export const selectLanguageMap = createSelector([selectSlice], (state) => {
  const map: Record<string, string> = {};
  state.items.forEach((l) => {
    map[l.code] = l.name;
  });
  return map;
});
